import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NavigationData, PaginatedCustomerAssignResponse } from '../models/response.model';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { UserState } from '../state/UserState';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root'
})
export class CustomerAssignService {
  private readonly STORAGE_KEY = 'customer-assign-navigation-data';
  public navigationDataSubject = new BehaviorSubject<NavigationData | null>(this.loadFromStorage());
  public navigationData$ = this.navigationDataSubject.asObservable();
  public http = inject(HttpClient);
  public store = inject(Store);

  constructor() {}

  private loadFromStorage(): NavigationData | null {
    try {
      const stored = sessionStorage.getItem(this.STORAGE_KEY);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      console.warn('Failed to load navigation data from storage:', error);
      return null;
    }
  }

  private saveToStorage(data: NavigationData | null): void {
    try {
      if (data) {
        sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
      } else {
        sessionStorage.removeItem(this.STORAGE_KEY);
      }
    } catch (error) {
      console.warn('Failed to save navigation data to storage:', error);
    }
  }

  setNavigationData(data: NavigationData): void {
    this.saveToStorage(data);
    this.navigationDataSubject.next(data);
  }

  getCustomerData(
    searchString: string,
    page: number,
    limit: number,
    uri: string,
    service: string,
    specId: string
  ): Observable<PaginatedCustomerAssignResponse> {
    const url = `${environment[service]}${environment.serviceUris[uri]}`;
    return this.http.get<PaginatedCustomerAssignResponse>(url, {
      params: {
        searchString: searchString,
        userLogin: this.store.selectSnapshot(UserState.getUserName),
        page: page,
        pageSize: limit,
        specId: specId
      }
    });
  }

  assignCustomerCasingCredit(uri: string, id: any, customerIds: string[]): Observable<any> {
    const url = `${environment.backOfficeUrl}${environment.serviceUris[uri]}/${id}`;
    const request = {
      customerFks: customerIds
    };
    return this.http.post<any>(url, request);
  }
}
